export const AnalyticsEventEnum = Object.freeze({
    CarList: 'CarList',
    Showroom: 'Showroom',
    ButtonPress: 'ButtonPress',
    Basket: 'Basket',
});